import React from 'react';

const GlobalContext = React.createContext({
    global: null,
    updateGlobal: () => {}
});

export { GlobalContext };